module.exports = __webpack_public_path__ + "components/MapControl/svg/Obiekt sportowy_boisko.svg?fe0ee23d";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Obiekt sportowy_boisko.svg
// module id = 2024
// module chunks = 0